class SnackbarService {
    constructor() {
        this.app = null;
    }

    install(app) {
        this.app = app;
        app.config.globalProperties.$snackbar = this;
        app.provide('snackbar', this);
    }

    /**
     * Open a snackbar/toast.
     * Compatible with Buefy's snackbar signature.
     *
     * @param {Object} params
     * @param {string} params.message
     * @param {string} [params.type] - 'is-success', 'is-danger', 'is-warning', 'is-info'
     * @param {string} [params.position] - 'is-bottom-right', 'is-top', etc.
     * @param {number} [params.duration] - Duration in ms
     * @param {boolean} [params.indefinite] - If true, stays until closed
     * @param {boolean} [params.queue] - If false, clears previous toasts (PrimeVue handles this differently)
     * @param {string} [params.actionText] - Label for action button
     * @param {Function} [params.onAction] - Callback for action button
     */
    open(params) {
        if (this.app) {
            const $toast = this.app.config.globalProperties.$toast;
            if ($toast) {
                return this.openPrimeVueToast(params);
            }
        }

        console.warn('PrimeVue toast service is not available.');
        return { close: () => {} };
    }

    openPrimeVueToast(params) {
        const $toast = this.app.config.globalProperties.$toast;

        const severityMap = {
            'is-success': 'success',
            'is-danger': 'error',
            'is-warning': 'warn',
            'is-info': 'info',
        };

        const severity = severityMap[params.type] || 'info';
        const life = params.indefinite ? 365 * 24 * 60 * 60 * 1000 : params.duration || 3000; // 1 year if indefinite

        const message = {
            severity: severity,
            summary: severity.charAt(0).toUpperCase() + severity.slice(1),
            detail: params.message,
            life: life,
            actionLabel: params.actionText,
            onAction: params.onAction,
            group: params.position === 'is-bottom-left' ? 'global-errors' : 'default',
        };

        $toast.add(message);

        return {
            close: () => {
                $toast.remove(message);
            },
        };
    }

    /**
     * Remove all toasts in a specific group
     * @param {string} group - The group name to clear
     */
    removeGroup(group) {
        if (this.app) {
            const $toast = this.app.config.globalProperties.$toast;
            if ($toast) {
                $toast.removeGroup(group);
                return;
            }
        }
    }
}

// Export a singleton instance
const snackbarService = new SnackbarService();
export default snackbarService;
